import { DoqFaceSvgProps } from '../types';

const DashboardBellyMissingOrg = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 96 96"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_5066_204434)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-dashboard-belly-missing-org">
        <circle cx="48" cy="48" r="48" fill="white" />
        <path d="M 72,96 A 48,48 0 0,1 24,96 L 48,48 Z" fill="black" />
      </mask>
      <circle
        cx="48"
        cy="48"
        r="48"
        fill="#E8D4FF"
        mask="url(#bottom-mask-dashboard-belly-missing-org)"
      />
      <mask
        id="mask0_5066_204434"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="96"
        height="96"
      >
        <circle cx="48" cy="48" r="48" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_5066_204434)">
        <rect x="24" y="36" width="48" height="60" fill="white" />
      </g>
      <path
        d="M42.5992 55.2004C43.9247 55.2004 44.9992 54.1259 44.9992 52.8004C44.9992 51.4749 43.9247 50.4004 42.5992 50.4004C41.2737 50.4004 40.1992 51.4749 40.1992 52.8004C40.1992 54.1259 41.2737 55.2004 42.5992 55.2004Z"
        fill="#2974C4"
      />
      <path
        d="M53.3992 55.2004C54.7247 55.2004 55.7992 54.1259 55.7992 52.8004C55.7992 51.4749 54.7247 50.4004 53.3992 50.4004C52.0737 50.4004 50.9992 51.4749 50.9992 52.8004C50.9992 54.1259 52.0737 55.2004 53.3992 55.2004Z"
        fill="#2974C4"
      />
      <path
        d="M43.1992 61.7992C43.1992 61.4678 43.4678 61.1992 43.7992 61.1992H52.1992C52.5306 61.1992 52.7992 61.4678 52.7992 61.7992C52.7992 62.1306 52.5306 62.3992 52.1992 62.3992H43.7992C43.4678 62.3992 43.1992 62.1306 43.1992 61.7992Z"
        fill="#2974C4"
      />
      <path
        opacity="0.99"
        d="M72.0229 32.5227C72.0229 32.5227 71.2069 27.1145 69.9246 23.763C68.6419 20.4168 66.5426 14.9957 63.3928 13.5886C58.4941 11.4004 48.0008 11.4004 48.0008 11.4004C48.0008 11.4004 38.3203 11.4004 32.6055 13.5886C29.3965 14.8193 27.3586 20.4168 26.0769 23.763C24.7947 27.1145 23.9776 32.5227 23.9776 32.5227C23.9776 32.5227 20.3622 34.0678 17.0987 35.8737C13.8325 37.6765 11.4977 40.766 10.8008 44.1165C11.8507 54.4202 23.8607 58.8004 23.8607 58.8004C23.8607 58.8004 23.8607 50.2983 24.4428 47.3365C25.0265 44.3742 26.3076 43.0841 31.3244 40.8965C36.3369 38.7077 48.0008 37.932 48.0008 37.932C48.0008 37.932 59.6626 38.7077 64.6766 40.8965C69.6907 43.0841 70.9746 44.3742 71.5583 47.3365C72.1393 50.2983 72.1393 58.8004 72.1393 58.8004C72.1393 58.8004 84.1503 54.4202 85.2008 44.1165C84.5007 40.766 82.1685 37.6765 78.9029 35.8737C75.6383 34.0678 72.0229 32.5227 72.0229 32.5227Z"
        fill="#2B75C5"
      />
      <path
        opacity="0.99"
        d="M25.6027 25.1996C25.6027 25.1996 36.5904 21.5996 48.001 21.5996C59.4116 21.5996 70.4058 25.1996 70.4058 25.1996L71.3807 28.7996C71.3807 28.7996 59.401 25.6883 48.001 25.6883C36.601 25.6883 24.6387 28.7996 24.6387 28.7996L25.6027 25.1996Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.0008 32.5226C72.0008 32.5226 67.0425 31.2873 60.0008 30.5401C52.959 29.7928 52.2533 29.6797 48.0008 29.6797C43.7482 29.6797 42.9527 29.6827 36.1955 30.4275C29.4383 31.1723 23.9776 32.5226 23.9776 32.5226C23.9776 32.5226 20.3622 34.0676 17.0987 35.8736C13.8325 37.6763 11.4977 40.7659 10.8008 44.1164C11.8507 54.4201 23.8607 58.8003 23.8607 58.8003C23.8607 58.8003 23.8607 50.2982 24.4428 47.3364C25.0265 44.3741 26.3076 43.084 31.3244 40.8963C36.3369 38.7076 48.0008 37.9319 48.0008 37.9319C48.0008 37.9319 59.6626 38.7076 64.6766 40.8963C69.6907 43.084 70.9746 44.3741 71.5583 47.3364C72.1393 50.2982 72.1393 58.8003 72.1393 58.8003C72.1393 58.8003 84.1503 54.4201 85.2008 44.1164C84.5007 40.7659 82.1685 37.6763 78.9029 35.8736C75.6383 34.0676 72.0008 32.5226 72.0008 32.5226Z"
        fill="#0D3E72"
      />
      <circle
        cx="53.4004"
        cy="53.1016"
        r="4.5"
        fill="#D9DEE3"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.8661 56.6415C56.822 57.9568 55.2091 58.8004 53.3992 58.8004C50.2512 58.8004 47.6992 56.2484 47.6992 53.1004C47.6992 49.9524 50.2512 47.4004 53.3992 47.4004C56.5472 47.4004 59.0992 49.9524 59.0992 53.1004C59.0992 53.2533 59.0932 53.4047 59.0814 53.5546C59.0936 53.6034 59.0998 53.6545 59.0992 53.7071L58.9492 67.0571C58.9455 67.3885 58.6738 67.6541 58.3425 67.6504C58.0111 67.6466 57.7455 67.375 57.7493 67.0436L57.8661 56.6415ZM57.8992 53.1004C57.8992 55.5857 55.8845 57.6004 53.3992 57.6004C50.9139 57.6004 48.8992 55.5857 48.8992 53.1004C48.8992 50.6151 50.9139 48.6004 53.3992 48.6004C55.8845 48.6004 57.8992 50.6151 57.8992 53.1004Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M33.6012 69.5996C32.2757 69.5996 31.2012 70.6741 31.2012 71.9996V76.7996C31.2012 78.1251 32.2757 79.1996 33.6012 79.1996H38.4012C39.7267 79.1996 40.8012 78.1251 40.8012 76.7996V71.9996C40.8012 70.6741 39.7267 69.5996 38.4012 69.5996H33.6012Z"
          fill="#2974C4"
        />
        <path
          d="M45.6012 69.5996C44.2757 69.5996 43.2012 70.6741 43.2012 71.9996V76.7996C43.2012 78.1251 44.2757 79.1996 45.6012 79.1996H50.4012C51.7267 79.1996 52.8012 78.1251 52.8012 76.7996V71.9996C52.8012 70.6741 51.7267 69.5996 50.4012 69.5996H45.6012Z"
          fill="#2974C4"
        />
        <path
          d="M55.2012 71.9996C55.2012 70.6741 56.2757 69.5996 57.6012 69.5996H62.4012C63.7267 69.5996 64.8012 70.6741 64.8012 71.9996V76.7996C64.8012 78.1251 63.7267 79.1996 62.4012 79.1996H57.6012C56.2757 79.1996 55.2012 78.1251 55.2012 76.7996V71.9996Z"
          fill="#2974C4"
        />
        <path
          d="M33.6012 81.5996C32.2757 81.5996 31.2012 82.6741 31.2012 83.9996V88.7996C31.2012 90.1251 32.2757 91.1996 33.6012 91.1996H38.4012C39.7267 91.1996 40.8012 90.1251 40.8012 88.7996V83.9996C40.8012 82.6741 39.7267 81.5996 38.4012 81.5996H33.6012Z"
          fill="#2974C4"
        />
        <path
          d="M43.2012 83.9996C43.2012 82.6741 44.2757 81.5996 45.6012 81.5996H50.4012C51.7267 81.5996 52.8012 82.6741 52.8012 83.9996V88.7996C52.8012 90.1251 51.7267 91.1996 50.4012 91.1996H45.6012C44.2757 91.1996 43.2012 90.1251 43.2012 88.7996V83.9996Z"
          fill="#2974C4"
        />
        <path
          d="M57.6012 81.5996C56.2757 81.5996 55.2012 82.6741 55.2012 83.9996V88.7996C55.2012 90.1251 56.2757 91.1996 57.6012 91.1996H62.4012C63.7267 91.1996 64.8012 90.1251 64.8012 88.7996V83.9996C64.8012 82.6741 63.7267 81.5996 62.4012 81.5996H57.6012Z"
          fill="#2974C4"
        />
      </g>
      <path
        d="M45.0012 74.4004C45.0012 75.9634 46.1802 77.2504 47.7012 77.4004V71.4004C46.1802 71.5504 45.0012 72.8374 45.0012 74.4004Z"
        fill="white"
      />
      <path
        d="M48.3102 71.4004C49.7292 71.5414 50.8602 72.6754 51.0012 74.0974H48.3102V71.4004Z"
        fill="white"
      />
      <path
        d="M51.0012 74.7034C50.8602 76.1254 49.7322 77.2594 48.3102 77.4004V74.7034H51.0012Z"
        fill="white"
      />
      <path
        d="M62.7012 72.0004H61.5012V77.1004H62.7012V72.0004Z"
        fill="white"
      />
      <path
        d="M57.3012 73.5004H58.5012V77.1004H57.3012V73.5004Z"
        fill="white"
      />
      <path
        d="M59.4012 74.7004H60.6012V77.1004H59.4012V74.7004Z"
        fill="white"
      />
      <path
        d="M34.278 74.3428C34.0444 74.5412 33.6988 74.8132 33.2412 75.1588V75.6004H35.5596V75.106H34.1388C34.6124 74.7476 34.9644 74.4324 35.1948 74.1604C35.4252 73.8884 35.5404 73.6148 35.5404 73.3396C35.5404 73.1348 35.4876 72.9572 35.382 72.8068C35.2764 72.6564 35.1356 72.5428 34.9596 72.466C34.7836 72.3892 34.59 72.3508 34.3788 72.3508C34.1484 72.3508 33.9276 72.3956 33.7164 72.4852C33.5084 72.5716 33.3356 72.698 33.198 72.8644L33.5244 73.234C33.63 73.1124 33.7548 73.018 33.8988 72.9508C34.046 72.8836 34.2092 72.85 34.3884 72.85C34.5484 72.85 34.6844 72.8932 34.7964 72.9796C34.9116 73.0628 34.9692 73.1828 34.9692 73.3396C34.9692 73.49 34.9132 73.6452 34.8012 73.8052C34.6892 73.962 34.5148 74.1412 34.278 74.3428Z"
        fill="white"
      />
      <path
        d="M36.6671 75.0532C36.5071 74.9828 36.3759 74.8884 36.2735 74.77L35.9711 75.1396C36.0863 75.2932 36.2479 75.418 36.4559 75.514C36.6671 75.61 36.9087 75.658 37.1807 75.658C37.4239 75.658 37.6351 75.618 37.8143 75.538C37.9967 75.458 38.1375 75.3476 38.2367 75.2068C38.3359 75.066 38.3855 74.906 38.3855 74.7268C38.3855 74.5732 38.3471 74.4388 38.2703 74.3236C38.1935 74.2084 38.0975 74.1204 37.9823 74.0596C37.8671 73.9956 37.7535 73.9588 37.6415 73.9492C37.8271 73.9172 37.9887 73.8372 38.1263 73.7092C38.2671 73.578 38.3375 73.4132 38.3375 73.2148C38.3375 72.9492 38.2319 72.7396 38.0207 72.586C37.8095 72.4292 37.5295 72.3508 37.1807 72.3508C36.9279 72.3508 36.7023 72.3972 36.5039 72.49C36.3087 72.5796 36.1455 72.7012 36.0143 72.8548L36.3023 73.2052C36.5391 72.9684 36.8143 72.85 37.1279 72.85C37.3167 72.85 37.4719 72.89 37.5935 72.97C37.7151 73.0468 37.7759 73.1572 37.7759 73.3012C37.7759 73.442 37.7151 73.5476 37.5935 73.618C37.4751 73.6884 37.3167 73.7236 37.1183 73.7236C36.9103 73.7236 36.7871 73.722 36.7487 73.7188V74.2228C36.7807 74.2196 36.9039 74.218 37.1183 74.218C37.5919 74.218 37.8287 74.3684 37.8287 74.6692C37.8287 74.8196 37.7695 74.9396 37.6511 75.0292C37.5327 75.1156 37.3695 75.1588 37.1615 75.1588C36.9919 75.1588 36.8271 75.1236 36.6671 75.0532Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.3372 85.2004C45.2444 85.45 45.198 85.7172 45.198 86.002C45.198 86.2868 45.2444 86.5556 45.3372 86.8084C45.43 87.058 45.5724 87.2628 45.7644 87.4228C45.9564 87.5796 46.1948 87.658 46.4796 87.658C46.7644 87.658 47.0028 87.5796 47.1948 87.4228C47.3868 87.2628 47.5292 87.058 47.622 86.8084C47.7148 86.5556 47.7612 86.2868 47.7612 86.002C47.7612 85.7172 47.7148 85.45 47.622 85.2004C47.5292 84.9476 47.3868 84.7428 47.1948 84.586C47.0028 84.4292 46.7644 84.3508 46.4796 84.3508C46.1948 84.3508 45.9564 84.4292 45.7644 84.586C45.5724 84.7428 45.43 84.9476 45.3372 85.2004ZM47.0172 85.1764C47.1324 85.3908 47.19 85.666 47.19 86.002C47.19 86.338 47.1324 86.6148 47.0172 86.8324C46.902 87.05 46.7228 87.1588 46.4796 87.1588C46.2364 87.1588 46.0572 87.05 45.942 86.8324C45.8268 86.6148 45.7692 86.338 45.7692 86.002C45.7692 85.666 45.8252 85.3908 45.9372 85.1764C46.0524 84.9588 46.2332 84.85 46.4796 84.85C46.726 84.85 46.9052 84.9588 47.0172 85.1764Z"
        fill="white"
      />
      <path
        d="M48.0886 84.8932H49.7494L48.5398 87.6004H49.1542L50.3974 84.7876V84.3988H48.0886V84.8932Z"
        fill="white"
      />
      <path
        d="M59.7012 89.4004C58.1802 89.2504 57.0012 87.9634 57.0012 86.4004C57.0012 84.8374 58.1802 83.5504 59.7012 83.4004V89.4004Z"
        fill="white"
      />
      <path
        d="M60.3102 89.4004C61.7322 89.2594 62.8602 88.1254 63.0012 86.7034H60.3102V89.4004Z"
        fill="white"
      />
      <path
        d="M38.7012 85.8004C39.0312 85.8004 39.3012 85.5304 39.3012 85.2004C39.3012 84.8704 39.0312 84.6004 38.7012 84.6004C38.3712 84.6004 38.1012 84.8704 38.1012 85.2004C38.1012 85.2544 38.1072 85.3054 38.1222 85.3534L37.0572 86.4214C37.0092 86.4064 36.9552 86.4004 36.9012 86.4004C36.8472 86.4004 36.7932 86.4064 36.7452 86.4214L35.9802 85.6564C35.9952 85.6084 36.0012 85.5544 36.0012 85.5004C36.0012 85.1704 35.7312 84.9004 35.4012 84.9004C35.0712 84.9004 34.8012 85.1704 34.8012 85.5004C34.8012 85.5544 34.8072 85.6084 34.8222 85.6564L33.4542 87.0214C33.4062 87.0064 33.3552 87.0004 33.3012 87.0004C32.9712 87.0004 32.7012 87.2704 32.7012 87.6004C32.7012 87.9304 32.9712 88.2004 33.3012 88.2004C33.6312 88.2004 33.9012 87.9304 33.9012 87.6004C33.9012 87.5464 33.8952 87.4954 33.8802 87.4474L35.2452 86.0794C35.2932 86.0944 35.3472 86.1004 35.4012 86.1004C35.4552 86.1004 35.5092 86.0944 35.5572 86.0794L36.3222 86.8444C36.3072 86.8924 36.3012 86.9464 36.3012 87.0004C36.3012 87.3304 36.5712 87.6004 36.9012 87.6004C37.2312 87.6004 37.5012 87.3304 37.5012 87.0004C37.5012 86.9464 37.4952 86.8924 37.4802 86.8444L38.5482 85.7794C38.5962 85.7944 38.6472 85.8004 38.7012 85.8004Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5066_204434">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { DashboardBellyMissingOrg };
